/*
 * Handles the saving display shown while a save is occuring.
 */

define(["marionette", "messaging/messenger", "modules/savingDisplay/savingDisplayView"], function (
  Marionette,
  Messenger,
  SavingDisplayView,
) {
  //used as context for the timer
  var _this;
  var SavingDisplayModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "savingDisplay";
      this.region = options.region;
      this._setUpVents();
      _this = this;
    },
    show: function () {
      _this.view = new SavingDisplayView.savingDisplayView();
      _this.region.backdrop = "static"; //do not allow the modal to close on background click
      delete _this.timerId; //get rid of timer id
      _this.showRegion(_this.view);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:saving:display",
        function () {
          //wait 1/4 second before showing the saving display
          this.timerId = window.setTimeout(_this.show, 250);
        },
        this,
      );

      Messenger.vent.on(
        "close:saving:display",
        function () {
          //clear timer
          if (this.timerId) {
            window.clearTimeout(this.timerId);
            delete this.timerId;
          } else {
            this.region.$el.modal("hide");
          }
        },
        this,
      );
    },
  });

  return SavingDisplayModule;
});
